import { gql } from '@apollo/client';

export const CampaignVendorsQuery = gql`
  query CampaignVendors($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      transferPhoneInbound
      transferPhoneOutbound
      ivrAudioUrls {
        inbound
        scheduled
        unscheduled
      }
      twilioSubAccount {
        id
        createdAt
        friendlyName
        twilioAccountSid
      }
      vendorAccounts {
        created
        deleted
        id
        modified
        volume
        vendorId
      }
      agentPhones {
        phone
        status
        vendorId
      }
    }
  }
`;
